export class ApiError extends Error {
    status: number

    constructor(message: string, status: number) {
        super(message)
        this.name = 'ApiError'
        this.status = status
    }
}

type ApiOptions = {
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
    body?: unknown
    keepalive?: boolean
}

// Talks to the site's own server routes. Every call carries the header the server
// requires for changes, and errors come back as plain sentences safe to show.
export const api = async <T = unknown>(path: string, options: ApiOptions = {}): Promise<T> => {
    let response: Response

    try {
        response = await fetch(path, {
            method: options.method || 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-feedsmith-client': '1'
            },
            body: options.body === undefined ? undefined : JSON.stringify(options.body),
            credentials: 'same-origin',
            keepalive: options.keepalive
        })
    }
    catch {
        throw new ApiError('You seem to be offline. Check your connection and try again.', 0)
    }

    const data = await response.json().catch(() => null)

    if (!response.ok) {
        const message = data && typeof data.message === 'string' ? data.message : 'Something went wrong. Please try again.'

        throw new ApiError(message, response.status)
    }

    return data as T
}

export const errorMessage = (error: unknown): string => error instanceof Error ? error.message : 'Something went wrong. Please try again.'
